module.exports = __webpack_public_path__ + "static/Landing_image-eda129480638098e490b4490e955cc3f.jpg";